import { render, staticRenderFns } from "./TableTreeItem.vue?vue&type=template&id=236677ce&scoped=true&"
import script from "./TableTreeItem.vue?vue&type=script&lang=js&"
export * from "./TableTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236677ce",
  null
  
)

export default component.exports